import React, { useState, useEffect } from "react";
// import AboutWelcome from "./AboutWelcome/AboutWelcome";
// import Founder from "./Founder/Founder";
// import OurStory from "./OurStory/OurStory";
// import OurJourney from "./OurJourney/OurJourney";
// import OurTeam from "./OurTeam/OurTeam";
import Product from "../../Components/Home/Product/Products";
import Platform from "../../Components/Home/Platforms/Platforms";
import StartTrading from "./StartTrading/StartTrading";
import ProductWelcome from "./ProductWelcome/ProductWelcome";
import HowToStart from "../Products/HowToStart/HowToStart";
import EasyTrade from "./EasyTrade/EasyTrade";
import Faq from "./Faq/Faq";
import PricingPlan from "./PricingPlan/PricingPlan";
import PlatformNew from "./../Home/PlatformNew/PlatformNew";
import "./ProductsCustom.css";
import { Form } from "react-bootstrap";
function Products(props) {
  // const divStyle = {
  //   margin: "40px",
  //   border: "5px solid pink",
  // };
  let product=window.location.pathname;
   product=product.replace('/','');
  const [plan,setPlan]=useState('');
	const Plan_details=(evt)=>{
		setPlan(evt)
	}
  
  return (
    <>
      {/* <AboutWelcome />
      <Founder />
      <OurStory />
      <OurJourney />
      <OurTeam />
      <Awards /> */}
      <ProductWelcome />
      <Product />
      <HowToStart />
      <EasyTrade />
      <PricingPlan Plan_details={Plan_details} product={product}/>
      <StartTrading />
      {/* <Platform /> */}
      <PlatformNew />
      <Faq />
    </>
  );
}
export default Products;
